<template>
    <div class="body-map" :class="{ 'is-dark': $vuetify.theme.dark }">
        <div class="body-map-labels">
            <span>{{ $t('questions.body_front') }}</span>
            <span>{{ $t('questions.body_back') }}</span>
        </div>
        <div class="body-map-canvas">
            <img :src="bodyImg" alt="" draggable="false">
            <svg viewBox="0 0 640 690" preserveAspectRatio="xMidYMid meet">
                <g v-for="(zone, i) in zones" :key="i" class="bzone"
                    :class="{ sel: levelOf(zone.id) > 0, 'is-readonly': readonly }" @click="onZoneClick(zone.id)">
                    <path :d="zone.d" class="bzone-area" :style="zoneStyle(zone.id)" />
                    <text v-if="displayOf(zone.id) > 0" class="bzone-num" :x="zone.cx" :y="zone.cy" text-anchor="middle"
                        dominant-baseline="central" :fill="numColor(zone.id)">{{ displayOf(zone.id) }}</text>
                </g>
            </svg>
        </div>
    </div>
</template>

<script>
import zones from "@/config/body-map-zones.json";

const PAIN_COLORS = ['', '#FDE68A', '#FBBF24', '#FB923C', '#F1553B', '#8B1A1A'];

export default {
    name: "BodyMap",
    props: {
        levels: {
            type: Object,
            default: () => ({}),
        },
        values: {
            type: Object,
            default: null,
        },
        readonly: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            zones,
            bodyImg: require('@/assets/img/body-map.png'),
        }
    },
    methods: {
        levelOf(id) {
            return this.levels[id] || 0
        },
        displayOf(id) {
            return this.values ? (this.values[id] || 0) : this.levelOf(id)
        },
        onZoneClick(id) {
            if (this.readonly) return
            this.$emit('cycle', id)
        },
        zoneStyle(id) {
            const level = this.levelOf(id)
            if (!level) return {}
            const color = PAIN_COLORS[level]
            return { fill: color, fillOpacity: 0.65, stroke: color, strokeWidth: '1.5' }
        },
        numColor(id) {
            return this.levelOf(id) >= 4 ? '#ffffff' : '#4a2f12'
        },
    },
}
</script>

<style scoped>
.body-map {
    display: flex;
    flex-direction: column;
    gap: 2px;
}

.body-map-labels {
    display: flex;
}

.body-map-labels span {
    flex: 1;
    text-align: center;
    font-size: 10px;
    font-weight: 700;
    letter-spacing: 0.1em;
    text-transform: uppercase;
    color: var(--v-txtMuted-base);
}

.body-map-canvas {
    position: relative;
    max-width: 420px;
    width: 100%;
    margin: 0 auto;
}

.body-map-canvas img {
    display: block;
    width: 100%;
    height: auto;
    user-select: none;
    -webkit-user-drag: none;
    mix-blend-mode: multiply;
}

.is-dark .body-map-canvas img {
    filter: invert(1) hue-rotate(180deg);
    mix-blend-mode: screen;
}

.body-map-canvas svg {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
}

.bzone {
    cursor: pointer;
}

.bzone.is-readonly {
    cursor: default;
}

.bzone-area {
    fill: transparent;
    stroke: none;
    transition: fill 0.15s, stroke 0.15s;
}

.bzone:not(.sel):not(.is-readonly):hover .bzone-area {
    fill: rgba(232, 92, 92, 0.18);
    stroke: rgba(232, 92, 92, 0.5);
    stroke-width: 1.5;
}

.bzone-num {
    font-size: 18px;
    font-weight: 800;
    pointer-events: none;
}
</style>
